import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'combineArrays'
})
export class CombineArraysPipe<T> implements PipeTransform {
  transform(value: T[],other: T[]) {
    return [...value, ...other];
  }
}
